import { container } from '@debatdirect/common/src/modules/container.js';

export const getCursor = (keyPath) => container.get('structure').cursor(keyPath);
